import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { useParams } from 'react-router-dom';
import { fetchSOinfolist, fetchSOnoInfolist, fetchSORegister, updateSaleOrder } from '../../Store/PHPSlice/Sale/SaleOrder';
import { selectSOinfo, selectSOlistReg, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';


const SaleOrderEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        entryType: '0',
        sono: '',
        qtNo: '',
        firm: '',
        party: '',
        school: '',
        item: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        mulItem: [],
        totQty: '',
        userId: userdata?.ID
    });

    const [errors, setErrors] = useState({});
    const [itemData, setItemData] = useState([]);
    const soinfolist = useSelector(selectSONOinfolist);
    // const soinfolist = useSelector((state) => state.SaleOrderData.sonolist || { data: [], totQty: [], infoData: [] });

    const dispatch = useDispatch();
    // console.log(itemData);
    useEffect(() => {
        dispatch(fetchSOnoInfolist(Id));
    }, [dispatch, Id]);

    useEffect(() => {

        if (soinfolist.data && soinfolist.data.length > 0) {
            const item = soinfolist.data[0];
            const mulitems = soinfolist.data.map(val => val.itemNm);

            setFormData(prev => ({
                ...prev,
                dt: item.ordt,
                entryType: item.entryType,
                soId: item.soId,
                sono: item.sono,
                qtNo: item.quotNo !== null ? item.quotNo : '0',
                firm: item.firmNm,
                party: item.partyNm,
                school: item.schoolNm,
                item: item.itemNm,
                mcloth: item.mainClothId,
                mclothNm: item.mclothNm,
                m1cloth: item.m1Id,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2Id,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3Id,
                m3clothNm: item.m3clothNm,
                mulItem: mulitems
            }));
            const newObject = {
                data: soinfolist?.data,
                infoData: soinfolist?.infoData
            };
            setItemData(newObject);
        }
    }, [soinfolist]);

    useEffect(() => {
        if (formData.mulItem.length > 0) {
            const total = formData.mulItem.map(item => (
                itemData?.infoData?.[item].info?.map(val => val.qty)
            ));

            let flattenedArray = total.flat();
            let sum_flatArray = flattenedArray.reduce((acc, curr) => acc + parseFloat(curr), 0);

            setFormData(prev => ({
                ...prev,
                totQty: sum_flatArray
            }));
        }
    }, [itemData])


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleRateChange = (index, newValue, type, sizeIndex) => {
        // Make a shallow copy of the whole infoData object
        const updatedSoinfo = { ...itemData.infoData };  // Make a shallow copy of the infoData object
        const itemNm = formData.mulItem[index];  // Get the item name using the index

        // Get a copy of the item (do not modify the original directly)
        const updatedItem = { ...updatedSoinfo[itemNm] };

        // Copy the 'info' array (do not modify the original directly)
        const updatedInfo = [...updatedItem.info];

        // Recalculate totalQty and totalAmount
        let totalRate = 0;
        let totalQty = 0;
        let totalAmount = 0;

        updatedInfo.forEach((val) => {
            totalRate += parseFloat(val.rate || 0);   // Sum of rates
            totalQty += parseFloat(val.qty || 0);     // Sum of quantities
            totalAmount += (parseFloat(val.rate || 0) * parseFloat(val.qty || 0)); // Sum of amount (rate * qty)
        });

        // Update the specific row based on sizeIndex (the row index for rate/qty)
        updatedInfo[sizeIndex] = {
            ...updatedInfo[sizeIndex], // Keep other values unchanged
            [type]: newValue // Update the rate or qty based on 'type'
        };

        // Assign the updated values back to the item
        updatedItem.info = updatedInfo;
        updatedItem.totalQty = totalQty;
        updatedItem.totalAmount = totalAmount;

        // Reassign the updated item back to the shallow copy of infoData
        updatedSoinfo[itemNm] = updatedItem;

        // Now, update the state with the modified 'soinfolist'
        setItemData((prevData) => ({
            ...prevData, // Keep the other properties of the state unchanged
            infoData: updatedSoinfo // Replace the infoData with the updated one
        }));

    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertObject(formData, itemData) {
        const values = formData.mulItem.map((item) => (
            {
                info: itemData?.infoData[item]?.info,
                Id: itemData?.infoData[item]?.data?.ID,
                totqty: itemData?.infoData[item]?.info?.reduce((acc, val) => acc + parseFloat(val.qty), 0)
            }
        ));
        const data = {
            dt: formData.dt,
            qtNo: formData.qtNo,
            saledata: values,
            userId: formData.userId
        }
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObject = convertObject(formData, itemData);
        // console.log(finalObject);

        dispatch(updateSaleOrder(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Sale Order Updated");
                // window.location.reload();
                alert('Sale Order Updated');
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <div style={{ margin: '1% 1%' }}>
                <h2>Sale Order Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='entryType'>Entry Type:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='entryType'

                                                >
                                                    {formData.entryType || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='sono'>Sale Order No.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='sono'

                                                >
                                                    {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.qtNo !== '0' &&
                                    <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='qtNo'>Quot No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='qtNo'

                                                    >
                                                        {formData.qtNo || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='firm'>Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='firm'

                                                >
                                                    {formData.firm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='party'>Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='party'

                                                >
                                                    {formData.party || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='item'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='item'

                                                >
                                                    {formData.item || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='school'>School:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='school'

                                                >
                                                    {formData.school || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mclothNm'>Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mclothNm'

                                                >
                                                    {formData.mclothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.m1cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-1:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='m1clothNm'

                                                    >
                                                        {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m2cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2clothNm'>Matching-2:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='m2clothNm'

                                                    >
                                                        {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {formData.m3cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m3clothNm'>Matching-3:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='m3clothNm'

                                                    >
                                                        {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totQty'>Total Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='totQty'

                                                >
                                                    {formData.totQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* <Grid item xs={10} md={10}>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Item Name</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    {itemData.length > 0 ? itemData.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {formData.qtNo !== '0' ?
                                                    (<TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.mclothNm} <br /> {formData.m1cloth !== '0' && formData.m1clothNm}<br />
                                                            {formData.m2cloth !== '0' && formData.m2clothNm} <br /> {formData.m3cloth !== '0' && formData.m3clothNm}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate</TableCell>
                                                        {itemData.length > 0 ? itemData.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                        )) : ''}
                                                    </TableRow>) :
                                                    (<TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.mclothNm} <br /> {formData.m1cloth !== '0' && formData.m1clothNm}<br />
                                                            {formData.m2cloth !== '0' && formData.m2clothNm} <br /> {formData.m3cloth !== '0' && formData.m3clothNm}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate</TableCell>

                                                        {itemData.length > 0 ? itemData.map((item, index) => (
                                                            <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }} key={index}>
                                                                <input
                                                                    type="text"
                                                                    value={formData.rate[index]}
                                                                    onChange={(e) => handleRateChange(index, e.target.value)}
                                                                    style={{ width: '40px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        )) : ''}
                                                    </TableRow>)
                                                }
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>

                                                    {itemData.length > 0 ? itemData.map((item, index) => (
                                                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }} key={index}>
                                                            <input
                                                                type="text"
                                                                value={formData.qty[index]}
                                                                onChange={(e) => handleQtyChange(index, e.target.value)}
                                                                style={{ width: '40px', padding: '1px' }}
                                                            />
                                                        </TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid> */}

                                {
                                    formData.mulItem.length > 0 &&
                                    formData.mulItem.map((itemNm, index) => {
                                        const item = itemData?.infoData?.[itemNm]; // Safely access infoData[itemNm]

                                        // Check if item exists and if info is iterable (array)
                                        if (!item || !Array.isArray(item.info)) return null;

                                        const totalValues = item.info.reduce(
                                            (totals, val) => {
                                                totals.totalRate += parseFloat(val.rate || 0); // Sum of rates
                                                totals.totalQty += parseFloat(val.qty || 0);   // Sum of quantities
                                                totals.totalAmount += parseFloat(val.rate || 0) * parseFloat(val.qty || 0); // Sum of amount (rate * qty)
                                                return totals;
                                            },
                                            { totalRate: 0, totalQty: 0, totalAmount: 0 } // Initial totals
                                        );

                                        return (
                                            item.info.length > 0 && (
                                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, margin: '1% 2%', fontSize: '14px', width: '90%', display: 'flex' }} key={index}>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow className="tbl-row">
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Particulars</TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                    {itemNm} <br />
                                                                    {item?.data?.mclothNm !== "0" ? item?.data?.mclothNm : ""} <br />
                                                                    {item?.data?.m1clothNm !== "0" ? item?.data?.m1clothNm : ""} <br />
                                                                    {item?.data?.m2clothNm !== "0" ? item?.data?.m2clothNm : ""} <br />
                                                                    {item?.data?.m3clothNm !== "0" ? item?.data?.m3clothNm : ""}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>

                                                    <Table>
                                                        <TableHead>
                                                            <TableRow className="tbl-row">
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Size</TableCell>
                                                                {item.info.map((val, valIndex) => (
                                                                    <TableCell key={valIndex} sx={{ p: 1, border: "1px solid #000" }} align="center">
                                                                        {val.size}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Rate</TableCell>
                                                                {item.info.map((val, valIndex) => (
                                                                    <TableCell key={valIndex} sx={{ p: 1, border: "1px solid #000" }} align="center">
                                                                        <input
                                                                            type="text"
                                                                            value={val.rate || '0'}
                                                                            onChange={(e) => handleRateChange(index, e.target.value, 'rate', valIndex)}
                                                                            style={{ width: '40px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Qty</TableCell>
                                                                {item.info.map((val, valIndex) => (
                                                                    <TableCell key={valIndex} sx={{ p: 1, border: "1px solid #000" }} align="center">
                                                                        <input
                                                                            type="text"
                                                                            value={val.qty || '0'}
                                                                            onChange={(e) => handleRateChange(index, e.target.value, 'qty', valIndex)}
                                                                            style={{ width: '40px', padding: '1px' }}
                                                                        />
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>

                                                    <Table>
                                                        <TableHead>
                                                            <TableRow className="tbl-row">
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Total Qty</TableCell>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">Total Amount</TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                    {totalValues.totalQty}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                    {totalValues.totalAmount.toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )
                                        );
                                    })
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Update</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default SaleOrderEdit;
